import { render, staticRenderFns } from "./BookingTableDg.vue?vue&type=template&id=48f6494f&scoped=true"
import script from "./BookingTableDg.vue?vue&type=script&lang=js"
export * from "./BookingTableDg.vue?vue&type=script&lang=js"
import style0 from "./BookingTableDg.vue?vue&type=style&index=0&id=48f6494f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6494f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f6494f')) {
      api.createRecord('48f6494f', component.options)
    } else {
      api.reload('48f6494f', component.options)
    }
    module.hot.accept("./BookingTableDg.vue?vue&type=template&id=48f6494f&scoped=true", function () {
      api.rerender('48f6494f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/BookingTableDg.vue"
export default component.exports